import { createApi } from '@reduxjs/toolkit/query/react'
import { gql } from 'graphql-request'
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query'

const pancakeAddress = '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82'
// Define a service using a base URL and expected endpoints
export const bitqueryApi = createApi({
  reducerPath: 'bitquery',
  baseQuery: graphqlRequestBaseQuery({ url: 'https://graphql.bitquery.io/' }),
  endpoints: builder => ({
    getPancakeswapPairsByToken0: builder.query<Array<any>, string | null>({
      query: (token: string | null) => ({
        document: gql`
          {
            ethereum (network: bsc){
              dexTrades( options: {desc: "count", limit: 500},
               baseCurrency: {is: "${token ? token : pancakeAddress}"}
              ) {
                count
                tradeAmount(in:USD)
                baseCurrency{
                  address
                  name
                  symbol
                }
                quoteCurrency{
                  address
                  name
                  symbol
                }
                quotePrice
                tx_count: count(uniq: txs)
                baseAmount(in: USD)
                quoteAmount (in: USD)
              }
            }
          }`,
        variables: null
      }),
      transformResponse: (response: any) => {
        return response.ethereum.dexTrades
      }
    }),
    getPancakeswapPairsByToken1: builder.query<Array<any>, string | null>({
      query: (token: string | null) => ({
        document: gql`
          {
            ethereum (network: bsc){
              dexTrades( options: {desc: "count", limit: 500},
              quoteCurrency: {is: "${token ? token : pancakeAddress}"}
              ) {
                count
                tradeAmount(in:USD)
                baseCurrency{
                  address
                  name
                  symbol
                }
                quoteCurrency{
                  address
                  name
                  symbol
                }
                quotePrice
                tx_count: count(uniq: txs)
                baseAmount(in: USD)
                quoteAmount (in: USD)
              }
            }
          }`,
        variables: null
      }),
      transformResponse: (response: any) => {
        return response.ethereum.dexTrades
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPancakeswapPairsByToken0Query, useGetPancakeswapPairsByToken1Query } = bitqueryApi
